// ============================================================================
// mfaStep — decides whether someone must use two-step login (an authenticator
// app code) before the app opens. Only HQ (superuser/admin) needs it, because
// HQ can approve people, change roles and see everyone's details.
//   'none'      → open the app
//   'enroll'    → HQ without an authenticator app yet: show the QR code
//   'challenge' → HQ with an app, not yet verified this session: ask for code
// The database enforces the same rule (frame.is_hq() requires aal2).
// ============================================================================

const HQ_ROLES = ['superuser', 'admin'];

export function mfaStep({ role, currentLevel, hasFactor }) {
  if (!HQ_ROLES.includes(role)) return 'none';
  if (currentLevel === 'aal2') return 'none';
  return hasFactor ? 'challenge' : 'enroll';
}
